import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const fetchBranchWiseAttendanceData = async (data: any) => {
	const requestData = {
		fetchBranchWiseDataToken: data,
	};
	const URL = `${API_URL}BranchWiseAttendanceForToday`;
	console.log('API URL:', URL);
	console.log('Request params:', data);
	return makeApiCall(URL, requestData, 'POST');
	// return axios.post(URL, data, {
	// 	headers: { 'Content-type': 'application/json' },
	// });
};
